import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import EmployeeImportDataResultFile from "../model/EmployeeImportDataResultFile";

const DownloadEmployeeImportJobResultFileApiService = async (
  request: number
): Promise<EmployeeImportDataResultFile> => {
  const uri = `/employeeimportjob/${request}/download-import-file/`;
  const { data } = await axios.post(uri);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useDownloadEmployeeImportJobResultFileApiService = () =>
  useMutation<EmployeeImportDataResultFile, AxiosError, number>(
    "DownloadEmployeeImportJobResultFileApiService",
    DownloadEmployeeImportJobResultFileApiService
  );

export default useDownloadEmployeeImportJobResultFileApiService;
